class ProductTemplateCustom {
  constructor(container) {
    this.container = container;

    // Check if instance already initialized
    if (this.container.dataset.initialized === "true") return;
    this.container.dataset.initialized = "true"; // Mark as initialized

    this.variantData = JSON.parse(
      this.container.querySelector("[data-variants]").textContent
    );

    this.form = this.container.querySelector("form");
    this.variantSelect = this.form.querySelector('select[name="id"]');
    this.price = this.container.querySelector(".current-price");
    this.comparePrice = this.container.querySelector(".original-price");
    this.addToCartBtn = this.form.querySelector('[name="add"]');
    this.paymentBtn = this.container.querySelector(".shopify-payment-button");
    this.qtyVal = this.container.querySelector(".qty-val");
    this.qtyInput = this.container.querySelector(".qty-input");

    this.initQty();
    this.initVariantSelection();
    console.log("✅ ProductTemplateCustom initialized");
  }

  initQty() {
    const minusBtn = this.container.querySelector(".qty-btn.minus");
    const plusBtn = this.container.querySelector(".qty-btn.plus");

    // Remove existing listeners if any (prevent duplicates)
    minusBtn.replaceWith(minusBtn.cloneNode(true));
    plusBtn.replaceWith(plusBtn.cloneNode(true));

    this.container.querySelector(".qty-btn.minus").addEventListener("click", () => {
      let qty = parseInt(this.qtyVal.textContent);
      if (qty > 1) qty--;
      this.qtyVal.textContent = qty;
      this.qtyInput.value = qty;
      console.log("➖ Qty updated to:", qty);
    });

    this.container.querySelector(".qty-btn.plus").addEventListener("click", () => {
      let qty = parseInt(this.qtyVal.textContent);
      qty++;
      this.qtyVal.textContent = qty;
      this.qtyInput.value = qty;
      console.log("➕ Qty updated to:", qty);
    });
  }

  initVariantSelection() {
    const buttons = this.container.querySelectorAll(".variant-button");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const value = btn.dataset.value;
        const index = parseInt(btn.dataset.index);

        const selectedVariant = this.variantData.find((variant) => {
          return variant.options[index] === value;
        });

        if (selectedVariant) {
          this.variantSelect.value = selectedVariant.id;
          this.updatePrices(selectedVariant);
          this.updateButtonState(selectedVariant);
        }

        // Toggle active state
        buttons.forEach((b) => {
          if (b.dataset.index === btn.dataset.index) {
            b.classList.remove("active");
          }
        });
        btn.classList.add("active");
      });
    });
  }

  updatePrices(variant) {
    this.price.textContent = Shopify.formatMoney(variant.price, Shopify.money_format);
    if (variant.compare_at_price > variant.price) {
      this.comparePrice.textContent = Shopify.formatMoney(
        variant.compare_at_price,
        Shopify.money_format
      );
      this.comparePrice.style.display = "inline";
    } else {
      this.comparePrice.style.display = "none";
    }
  }

  updateButtonState(variant) {
    if (variant.available) {
      this.addToCartBtn.disabled = false;
      this.addToCartBtn.textContent = "Add to cart";
      if (this.paymentBtn) this.paymentBtn.style.display = "block";
    } else {
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.textContent = "Sold Out";
      if (this.paymentBtn) this.paymentBtn.style.display = "none";
    }
  }
}

// Main initialization
function initProductTemplates() {
  document.querySelectorAll(".product-template-custom-section").forEach((container) => {
    new ProductTemplateCustom(container);
  });
}

document.addEventListener("DOMContentLoaded", initProductTemplates);

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (e) => {
    const container = e.target;
    if (container.classList.contains("product-template-custom-section")) {
      new ProductTemplateCustom(container);
    }
  });
}
